import { PublishedBrandsCampaign, privateApi } from 'services';
import { UpdateBrandsCampaignsItem } from 'views/BrandsCampaignDetailsView/BrandsCampaignFormUtils';
import { CreateBrandsCampaign, UpdateBrandsCampaignsAdGroups, UpdatedBrandsCampaignsAdGroups } from './types';
import { BrandsChannel } from 'lib/enum/brands-channel.enum';
import { ManagedSocialCampaignProperty } from 'lib/enum/managed-social-campaign-proprty.enum';

const createCampaign = async (brandsCampaign: CreateBrandsCampaign): Promise<PublishedBrandsCampaign> =>
    privateApi.post<PublishedBrandsCampaign>('published-brands-campaigns', brandsCampaign);

const updateCampaign = async (
    brandsCampaignId: string,
    brandsCampaign: UpdateBrandsCampaignsItem,
): Promise<PublishedBrandsCampaign> =>
    privateApi.put<PublishedBrandsCampaign>(`published-brands-campaigns/${brandsCampaignId}`, brandsCampaign);

const updateAdGroups = async (
    brandsCampaignId: string,
    updateBrandsCampaignsAdGroups: UpdateBrandsCampaignsAdGroups,
): Promise<UpdatedBrandsCampaignsAdGroups> =>
    privateApi.put<UpdatedBrandsCampaignsAdGroups>(
        `brands-campaigns/${brandsCampaignId}/ad-groups`,
        updateBrandsCampaignsAdGroups,
    );

const activateCampaign = async (brandsCampaignId: string): Promise<PublishedBrandsCampaign> =>
    privateApi.post<PublishedBrandsCampaign>(`published-brands-campaigns/${brandsCampaignId}/activate`);

const deactivateCampaign = async (brandsCampaignId: string): Promise<PublishedBrandsCampaign> =>
    privateApi.post<PublishedBrandsCampaign>(`published-brands-campaigns/${brandsCampaignId}/deactivate`);

const addManagedSocialCampaign = async (
    brandsCampaignId: string,
    data: {
        uuid: string;
        channel: BrandsChannel;
        externalReference: string;
        running: boolean;
    },
): Promise<void> =>
    privateApi.post<void>(`published-brands-campaigns/${brandsCampaignId}/managed-social-campaigns`, data);

const linkExternalCampaign = async (
    brandsCampaignId: string,
    managedSocialCampaignId: string,
    data: {
        externalReference: string;
        running: boolean;
    },
): Promise<void> =>
    privateApi.post<void>(
        `published-brands-campaigns/${brandsCampaignId}/managed-social-campaigns/${managedSocialCampaignId}/link-external-campaign`,
        data,
    );

const addHistoricalManagedSocialCampaign = async (
    brandsCampaignId: string,
    data: {
        channel: BrandsChannel;
        externalReference: string;
    },
): Promise<void> =>
    privateApi.post<void>(`published-brands-campaigns/${brandsCampaignId}/historical-managed-social-campaigns`, data);

const markSocialCampaignPropertiesAsUpToDate = async (
    brandsCampaignId: string,
    managedSocialCampaignId: string,
    payload: {
        localStateHash: string;
        properties: ManagedSocialCampaignProperty[];
    },
): Promise<void> =>
    privateApi.post<void>(
        `published-brands-campaigns/${brandsCampaignId}/managed-social-campaigns/${managedSocialCampaignId}/mark-as-up-to-date`,
        payload,
        true,
    );

const overrideExternalReference = async (
    managedSocialCampaignId: string,
    data: {
        externalReference: string;
    },
): Promise<void> =>
    privateApi.post<void>(`managed-social-campaigns/${managedSocialCampaignId}/override-external-reference`, data);

export const PublishedBrandsCampaignGateway = {
    createCampaign,
    updateCampaign,
    updateAdGroups,
    activateCampaign,
    deactivateCampaign,
    addManagedSocialCampaign,
    linkExternalCampaign,
    addHistoricalManagedSocialCampaign,
    markSocialCampaignPropertiesAsUpToDate,
    overrideExternalReference,
};
